import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import classNames from "classnames";
import styles from "./ConstentTraditionalPage.module.css";
import { Toggle } from "../../components/Toggle/Toggle";
import { useLayoutStore } from "~/store";

export const ConstentTraditionalPage = ({ handleConsentChoice, loading }) => {
  const [agree, setAgree] = useState(false);
  const navigate = useNavigate();

  const { setShowFooter } = useLayoutStore();

  useEffect(() => {
    queueMicrotask(() => {
      setShowFooter(true);
    });
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>Update Communication Preferences</h2>

        <div className={styles.toggleContainer}>
          <span className={styles.toggleLabel}>Interest-Based Ads</span>
          <Toggle data-testid="consent-interest-based-ads" aria-label="Interest-Based Ads" initialState={agree} onChange={setAgree}></Toggle>
        </div>

        <p className={styles.text}>
          Interest-based ads from Marriott and Advertising Partners on Marriott
          channels and Advertising Partners’ platforms.
        </p>

        <div className={styles.buttonArea}>
          {loading ? (
            <div className={styles.loadingState}>
              <svg
                className={styles.spinner}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeOpacity="0.3"
                />
                <path
                  d="M12 2a10 10 0 0 1 10 10"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
              <span className={styles.loadingText}>
                Saving your preferences...
              </span>
            </div>
          ) : (
            <>
              <button
                data-testid="consent-save"
                onClick={() => handleConsentChoice(agree)}
                className={classNames(
                  styles.primaryButton,
                  "custom_click_track",
                )}
                data-custom_click_track_value={`Consent Traditional|'Save' button|internal`}
                type="button"
              >
                Save
              </button>
              {/* 
              <button
                className={classNames(
                  styles.secondaryButton,
                  "custom_click_track",
                )}
                data-custom_click_track_value={`Consent Traditional|'Cancel' button|internal`}
                onClick={() => navigate("/consent/thank-you")}
                type="button"
              >
                Cancel
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M9.13331 8.24267L5.83331 4.94267L6.77598 4L11.0186 8.24267L6.77598 12.4853L5.83331 11.5427L9.13331 8.24267Z"
                    fill="#1C1C1C"
                  />
                </svg>
              </button> */}
            </>
          )}
        </div>
        <p className={styles.textFooter}>
          By clicking the button above, you agree to receive interest-based ads
          from Marriott and Advertising Partners on Marriott channels and
          Advertising Partners’ platforms.
        </p>
      </div>
    </section>
  );
};
